import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { fetchLatestTransactions, selectTransactionDetails, selectTransactionsFirstLoad } from "../model"
import { TransactionsTable } from "./transactions-table"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { StatisticsBlock } from "@/shared/ui/statistics-block"
import ListBulletsSvg from '@/shared/assets/images/ListBullets.svg'
import MoneySvg from '@/shared/assets/images/Money.svg'
import PercentSvg from '@/shared/assets/images/Percent.svg'
import ChartBarSvg from '@/shared/assets/images/ChartBar.svg'
import { toLocaleString } from "@/shared/lib/to-locale-string"

export const CompanyTransactionsStatistics = () => {
    const dispatch = useAppDispatch()
    const transactionDetails = useAppSelector(selectTransactionDetails)
    const isFirstLoad = useAppSelector(selectTransactionsFirstLoad)

    useEffect(() => {
        if (isFirstLoad) {
            dispatch(fetchLatestTransactions())
        }
    }, [dispatch, isFirstLoad])

    return (
        <div className='flexbox'>
            <PageSubtitle title='Статистика' />
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 md:col-span-6 xxl:col-span-3">
                    <StatisticsBlock
                        className="screen:!py-5"
                        icon={ListBulletsSvg}
                        label='Количество транзакций'
                        value={toLocaleString(transactionDetails?.transactionCount || 0)}
                    />
                </div>
                <div className="col-span-12 md:col-span-6 xxl:col-span-3">
                    <StatisticsBlock
                        className="screen:!py-5"
                        icon={MoneySvg}
                        label='Сумма транзакций'
                        value={`${toLocaleString(transactionDetails?.totalSum || 0)} ₽`}
                    />
                </div>
                <div className="col-span-12 md:col-span-6 xxl:col-span-3">
                    <StatisticsBlock
                        className="screen:!py-5"
                        icon={PercentSvg}
                        label='Сумма скидок'
                        value={`${toLocaleString(transactionDetails?.totalDiscount || 0)} ₽`}
                    />
                </div>
                <div className="col-span-12 md:col-span-6 xxl:col-span-3">
                    <StatisticsBlock
                        className="screen:!py-5"
                        icon={ChartBarSvg}
                        label='Сумма НДС'
                        value={`${toLocaleString(transactionDetails?.totalTax || 0)} ₽`}
                    />
                </div>
            </div>
            <TransactionsTable />
        </div>
    )
}
